import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaskCollectionTravelMode } from '../../../enums/task-collection-travel-mode.enum';

@Component({
  selector: 'transport-icon-switch',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './transport-icon-switch.component.html',
  styleUrls: ['./transport-icon-switch.component.css'],
})
export class TransportIconSwitchComponent implements OnInit {
  @Input() mode!: TaskCollectionTravelMode;

  constructor() {}

  ngOnInit(): void {}

  protected readonly TaskCollectionTravelMode = TaskCollectionTravelMode;
}
